import actionButton from '../../genericTable/actionButtons/actionButton';

export class GenericTablePrintButton {
  cod = 'printButton';
  eventType = 'print';
  classImage = 'fa-light fa-print';
  elAttrVisibility = null;
  component = actionButton;
  constructor(classImage, elAttrVisibility) {
    this.classImage = classImage;
    this.elAttrVisibility = elAttrVisibility;
  }
}
